/**
 * This class contains all the information about the Google subscription offer details.
 * It might be either a plain base plan details or a base plan with the concrete offer details.
 */
export class ProductOfferDetails {
    constructor(basePlanId, offerId, offerToken, tags, pricingPhases, basePlan, installmentPlanDetails, introPhase, trialPhase, hasTrial, hasIntro, hasTrialOrIntro) {
        this.basePlanId = basePlanId;
        this.offerId = offerId;
        this.offerToken = offerToken;
        this.tags = tags;
        this.pricingPhases = pricingPhases;
        this.basePlan = basePlan;
        this.installmentPlanDetails = installmentPlanDetails;
        this.introPhase = introPhase;
        this.trialPhase = trialPhase;
        this.hasTrial = hasTrial;
        this.hasIntro = hasIntro;
        this.hasTrialOrIntro = hasTrialOrIntro;
    }
}
//# sourceMappingURL=ProductOfferDetails.js.map